/* F9: presentation-only translations for Releasit v2. Never read/write app or order state. */
(() => {
  'use strict';
  if (window.TBReleasitI18n) return;
  const config = document.querySelector('[data-tb-releasit-i18n]');
  if (!config) return;
  let map;
  try { map = JSON.parse(config.textContent); } catch { return; }
  if (!map.exact || !map.locale || map.locale === 'it') return;
  window.TBReleasitI18n = true;

  // Measured v2 roots: the PDP/cart app button and its dialog. Theme COD controls are excluded.
  const roots = '#rsi_form_wrapper, [id^="rsi_buy_now_button"]';
  const protectedNodes = 'script, style, template, select, option, textarea, input[type="hidden"], [contenteditable], .rsi-product-item-title, .rsi-product-item-name, .rsi-recommendation-product-title, .rsi-recommendation-title, .rsi-recommendation-content > [title], .rsi-upsell-title, .rsi-variant-selector, a[href*="/products/"], .rsi-onetick-text b';
  const attributes = ['placeholder', 'aria-label', 'title'];
  const observers = new Map(), pending = new Set(), written = new WeakMap();
  let frame = 0;
  // Capture formatted money verbatim; unsupported formats stay in the source language.
  const price = '(?:€[\\d.,]+|[\\d.,]+[\\u00a0 ]€)';
  const complete = new RegExp("^COMPLETA L'ORDINE - (" + price + ')$');
  const upsell = new RegExp('^Aggiungi (.+) a soli (' + price + ')$');
  const discount = /^COMPLETA L'ORDINE CON (\d+(?:[.,]\d+)?%) DI SCONTO$/;
  const orderUpsell = /^Aggiungi (.+) al tuo ordine!$/;
  function translate(value) {
    const text = value.trim();
    let next = Object.prototype.hasOwnProperty.call(map.exact, text) ? map.exact[text] : null;
    let match;
    if (next === null && (match = text.match(complete)) && map.complete) next = map.complete.replace('{price}', () => match[1]);
    if (next === null && (match = text.match(upsell)) && map.upsell) next = map.upsell.replace(/\{title\}|\{price\}/g, token => match[token === '{title}' ? 1 : 2]);
    if (next === null && (match = text.match(discount)) && map.discount) next = map.discount.replace('{discount}', () => match[1]);
    if (next === null && (match = text.match(orderUpsell)) && map.orderUpsell) next = map.orderUpsell.replace('{title}', () => match[1]);
    return typeof next === 'string' ? value.replace(text, () => next) : value;
  }
  function visible(element) {
    return !element.closest(protectedNodes + ', [hidden], [aria-hidden="true"]') && element.getClientRects().length > 0 && getComputedStyle(element).visibility === 'visible';
  }
  function write(node, key, value, set) {
    const record = written.get(node) || {};
    if (record[key] === value) return;
    const next = translate(value);
    if (next !== value) { set(next); record[key] = next; written.set(node, record); }
  }
  function apply(root) {
    if (!root.isConnected || !root.getClientRects().length) return;
    // The live upsell template is split around <b> product/title nodes. Translate only its
    // two literal text leaves, and only after verifying the complete Italian template.
    root.querySelectorAll('.rsi-onetick-text').forEach(element => {
      if (!visible(element) || !upsell.test(element.textContent.trim())) return;
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (!visible(node.parentElement)) continue;
        const text = node.data.trim();
        const next = text === 'Aggiungi' ? map.upsellBefore : text === 'a soli' ? map.upsellBetween : null;
        if (typeof next === 'string') node.data = node.data.replace(text, () => next);
      }
    });
    // Two narrow presentation exceptions to the protected title/select boundaries.
    // Shopify supplies this one product's localized title; never infer other product names.
    if (typeof map.oneTickTitle === 'string' && map.oneTickTitle.trim() && map.oneTickTitle !== 'Adesivi Reggi Parastinchi') {
      root.querySelectorAll('.rsi-onetick-text b').forEach(element => {
        if (!visible(element.closest('.rsi-onetick-text')) || element.textContent !== 'Adesivi Reggi Parastinchi') return;
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          if (walker.currentNode.data === 'Adesivi Reggi Parastinchi') walker.currentNode.data = map.oneTickTitle;
        }
      });
    }
    root.querySelectorAll('select[name="province_country_field"] option[value=""]').forEach(option => {
      const select = option.closest('select');
      if (option.textContent !== 'Provincia' || select.closest('[hidden], [aria-hidden="true"]') || !select.getClientRects().length || getComputedStyle(select).visibility !== 'visible') return;
      // An explicit empty value is required: options without value submit their text.
      if (typeof map.exact.Provincia === 'string' && map.exact.Provincia !== 'Provincia') option.textContent = map.exact.Provincia;
    });
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.data.trim() && visible(node.parentElement)) write(node, 'text', node.data, next => { node.data = next; });
    }
    [root, ...root.querySelectorAll('[placeholder], [aria-label], [title]')].forEach(element => {
      if (!visible(element)) return;
      attributes.forEach(name => {
        const value = element.getAttribute(name);
        if (value) write(element, name, value, next => element.setAttribute(name, next));
      });
    });
  }
  function schedule(root) {
    pending.add(root);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      pending.forEach(element => { apply(element); observers.get(element)?.takeRecords(); });
      pending.clear();
    });
  }
  function attach(root) {
    if (observers.has(root)) return;
    const observer = new MutationObserver(() => schedule(root));
    observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: [...attributes, 'open', 'hidden', 'class', 'style'] });
    observers.set(root, observer);
    schedule(root);
  }
  function discover(node) {
    if (node.nodeType !== 1 || node.closest(roots) && !node.matches(roots)) return;
    if (node.matches(roots)) attach(node);
    node.querySelectorAll(roots).forEach(attach);
  }
  document.querySelectorAll(roots).forEach(attach);
  // Only discovery/removal outside the app, no page text traversal or polling when absent.
  new MutationObserver(records => {
    observers.forEach((observer, root) => {
      if (!root.isConnected) { observer.disconnect(); observers.delete(root); pending.delete(root); }
    });
    records.forEach(record => record.addedNodes.forEach(discover));
  }).observe(document.body, { childList: true, subtree: true });
})();
